import {NgModule} from "@angular/core";
import {IntIconComponent} from "./int-icon.component";
import {CommonModule} from "@angular/common";

@NgModule({
  imports: [CommonModule],
  declarations: [IntIconComponent],
  exports: [IntIconComponent]
})
export class IntIconModule {}
